import React, { useState } from 'react'
import { ModalButton } from 'src/components/Global/Button/Button'
import { useTypedSelector } from 'src/redux/root-reducer'
import { useDispatch } from 'react-redux'
import { createPlanAction } from 'src/redux/actions/planAction'
import { Wrapper } from './style'
import { useNavigate } from 'react-router-dom'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import { addNairaSign } from 'src/utils/addNairaSign'
import useSnackbar from 'src/hooks/useSnackBar'
import { ModalTitleText, LabelText } from 'src/components/Global/Text/TitleText'

const PlanCreatedDetails = () => {
  const [error, isError] = useState(false)
  const [loading, setLoading] = useState(false)
  let planData: any = useTypedSelector(
    (state) => state.userPlanReducer.planForm
  )

  console.log(planData, 'modal')
  const Active = () => {
    if (planData.saving_type === 'automated') {
      return (
        <div className="description">
          <h3 className="data-title">Auto debit amount</h3>
          <p className="data">{addNairaSign(planData.auto_debit_amount)}</p>
        </div>
      )
    }
  }
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (
      !planData.amount_to_save ||
      !planData.start_date ||
      !planData.maturity_date
    ) {
      return isError(true)
    }
    setLoading(true)
    dispatch(createPlanAction({ planData, onSuccess, onError }))
  }
  const snackbar = useSnackbar()

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
    setTimeout(() => {
      if (planData.plan_type === 'general') {
        navigate('/general-savings')
      }
      if (planData.plan_type === 'target') {
        navigate('/target-savings')
      }
    }, 1500)
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: 'Error creating Your Plan',
      severity: 'error',
    })
  }

  return (
    <Wrapper>
      <form onSubmit={handleSubmit} className="content">
        <div>
          <div className="">
            <ModalTitleText>General Savings</ModalTitleText>
            <LabelText className="minus">
              Here is a quick overview of your general saving .
            </LabelText>
          </div>
          <div>
            <div className="description">
              <h3 className="data-title">Amount to Save</h3>
              <p className="data">{addNairaSign(planData.amount_to_save)}</p>
            </div>
            {Active()}
            <div className="description">
              <h3 className="data-title">Start Date</h3>
              <p className="data">{planData.start_date}</p>
            </div>
            <div className="description">
              <h3 className="data-title">End Date</h3>
              <p className="data">{planData.maturity_date}</p>
            </div>
          </div>
        </div>
        <div className="top">
          <ModalButton>Create Plan {loading && <Spinner />}</ModalButton>
        </div>
      </form>
    </Wrapper>
  )
}

export { PlanCreatedDetails }
